import styled from 'styled-components';
import { Tag, Descriptions, PageHeader } from 'antd';
import { useEffect, useState } from "react";
import { ancanaApi } from "../../api/ancanaApi";
import { useParams } from "react-router-dom";
import RecordTable from "../../components/RecordTable";
import { BalanceTransactionSlimModel, InvoiceModel } from "../../types/models";
import { financeAmtFormat } from "../../utils";


const Container = styled.div`
  overflow: scroll;

  .transactions-cont {
    height: 1000px;
  }
`;

function OwnerDetail() {
  const { owner_id } = useParams();
  const [houseOwner, setHouseOwner] = useState<any>();
  const [preferredDates, setPreferredDates] = useState<any[]>([]);
  const [ownerInvoices, setOwnerInvoices] = useState<any[]>([]);
  const [unitsOwned, setUnitsOwned] = useState<number>(1);

  useEffect(() => {
    ancanaApi.get(`unit-owners/${owner_id}/?expand=owner,unit`).then(res => {
      setHouseOwner(res.data);
    })
  }, []);

  useEffect(() => {
    if (houseOwner) {
      ancanaApi.get(`house-owner-preferred-date-range/?house_owner=${houseOwner.id}&page_size=25`).then(res => {
        setPreferredDates(res.data.results);
      });
      ancanaApi.get(`journal-invoices/?user=${houseOwner.owner.id}&page_size=100&expand=journal`).then(res => {
        setOwnerInvoices(res.data.results);
      });
      ancanaApi.get(`unit-owners/?owner=${houseOwner.owner.id}&page_size=1`).then(res => {
        setUnitsOwned(res.data.count);
      });
    }
  }, [houseOwner]);

  return (
    <Container className="anti-contento">
      <div className="contento">
        <div className="disp-flex h-stack">
          <div>
            <PageHeader
              onBack={() => window.history.back()}
              title={houseOwner?.owner.full_name}
              subTitle={houseOwner?.owner.email}
              className="mb-md"
            />
            <Descriptions
              layout="horizontal"
              column={1}
              bordered
              style={{ maxWidth: 600 }}
            >
              <Descriptions.Item label="First Name" labelStyle={{ fontWeight: 500 }}>
                {houseOwner?.owner.first_name}
              </Descriptions.Item>
              <Descriptions.Item label="Last Name" labelStyle={{ fontWeight: 500 }}>
                {houseOwner?.owner.last_name}
              </Descriptions.Item>
              <Descriptions.Item label="House" labelStyle={{ fontWeight: 500, width: 200 }}>
                {houseOwner?.unit.name}
                <br />
                <small>
                  <a href={`/owners/?owner=${houseOwner?.owner.id}`} target="_blank" rel="noreferrer">
                    {unitsOwned == 2 ? `(Owns one extra property)` : unitsOwned > 2 ? `(Owns ${unitsOwned - 1} extra properties)` : ''}
                  </a>
                </small>
              </Descriptions.Item>
              <Descriptions.Item label="Fractions" labelStyle={{ fontWeight: 500 }}>
                {houseOwner?.fraction_numbers.map((fn: number) => <Tag>#{fn}</Tag>)}
              </Descriptions.Item>
              <Descriptions.Item label="Preferred Weeks" labelStyle={{ fontWeight: 500 }}>
                {preferredDates.map(pd => <Tag>
                  <div>{pd.date_start}</div>
                  <div>{pd.date_end}</div>
                </Tag>)}
              </Descriptions.Item>
              <Descriptions.Item label="Cash Balance" labelStyle={{ fontWeight: 500 }}>
                {financeAmtFormat(houseOwner?.owner.stripe_accounts[0]?.mx_cash_balance/100)}
              </Descriptions.Item>
            </Descriptions></div>


          <div className="transactions-cont" style={{ maxWidth: 1000 }}>
            <RecordTable
              recordModel={BalanceTransactionSlimModel}
              recordsetFilters={{ customer: houseOwner?.owner.stripe_accounts[0]?.id }}
              columnMapper={(cols) => {
                return cols.map((col) => {
                  if (col.title === 'Transaction') {
                    const prevRender = col.render || ((r: any) => r.description);
                    return {
                      ...col,
                      render: (a, r, i) => {
                        const currInvoice = ownerInvoices.find(inv => inv.stripe_invoice === r.invoice);
                        return (
                          <div>{prevRender(a, r, i)}
                            {''}
                            {r.type === 'applied_to_payment' ? r.invoice ? (
                              <a href={!!currInvoice?.id ? `/invoices/${currInvoice?.id}` : `https://dashboard.stripe.com/acct_1FmmYDDIqmrOjGrM/invoices/${r.stripe_id}`} target="_blank" rel="noreferrer">
                                {!!currInvoice ? (
                                  `${currInvoice.auto_description}  ${unitsOwned > 1 ? ' - ' + currInvoice?.journal.content_object.unit.name : ''}`
                                ) : (
                                  `Stripe Invoice ${r.invoice}`
                                )}
                              </a>
                            ) : <i>No Invoice</i> : ''}
                          </div>
                        )
                      },
                      width: unitsOwned > 1 ? 320 : undefined
                    }
                  }
                  return col;
                });
              }}
              embedded
              viewOnly
              headerExtra={
                <RecordTable
                  recordModel={InvoiceModel}
                  modalView
                  recordsetFilters={!!houseOwner?.owner.id ? { user: houseOwner?.owner.id } : undefined}
                />
              }
            />
          </div>

        </div>

      </div>
    </Container>
  );
}

export default OwnerDetail;
